module.exports = __webpack_public_path__ + "img/skirting.02e49436.jpg";